import * as yup from 'yup';

import { EstadoPyLCodigoEnum } from '@/shared/interfaces';
import { emailYupValidation } from '../validationSchema';

export const updAgendaRecoordinacionPylSchema = yup.object({
  fecha: yup.string().optional().nullable(), // validate inside of form
  fecha_hora_instalacion: yup.string().optional().nullable(), // validate inside of form

  fullName: yup.string().required('El nombre es requerido'),

  // creado tras ok pyl - auto back
  numero_contrato: yup.string().optional(),
  url_contrato: yup.string().optional(),

  identificacion: yup.string().required('La identificación es requerida'),
  fecha_nacimiento: yup
    .string()
    .required('La fecha de nacimiento es requerida'),
  edad: yup.number().required('La edad es requerida'),
  direccion: yup.string().required('La dirección es requerida'),
  coordenadas: yup.string().required('Las coordenadas son requeridas'),
  condicion_residencia: yup
    .string()
    .required('La condición de residencia es requerida'),

  celular: yup.string().required('El celular es requerido'),
  // telefono_adicional: yup.string().optional(),
  email: emailYupValidation,
  parentesco_referencia: yup
    .string()
    .required('El parentesco es requerido')
    .max(15, 'La longitud máxima es 15 caracteres'),
  persona_referencia: yup
    .string()
    .required('La persona de referencia es requerida'),
  celular_referencia: yup
    .string()
    .required('El celular de referencia es requerido'),
  telefono_fijo_referencia: yup.string().optional(),
  telefono_fijo: yup.string().optional(),
  velocidad_internet: yup
    .string()
    .required('La velocidad de internet es requerida'),

  valor_instalacion: yup
    .string()
    .required('El valor de instalación es requerido'),
  valor_instalacion_sin_iva: yup
    .string()
    .required('El valor de instalación sin IVA es requerido'),
  valor_instalacion_total: yup
    .string()
    .required('El valor total de instalación es requerido'),
  segmentacion: yup.string().required('La segmentación es requerida'),
  puntaje_empresa: yup
    .string()
    .required('El puntaje de la empresa es requerido'),

  distancia_aproximada: yup
    .string()
    .required('La distancia aproximada es requerida'),
  detalle_instalacion: yup
    .string()
    .required('El detalle de instalación es requerido'),
  herramienta_utilizada: yup
    .string()
    .required('La herramienta utilizada es requerida'),
  numero_pisos: yup.number().required('El número de pisos es requerido'),
  numero_dispositivos: yup
    .number()
    .required('El número de dispositivos es requerido'),
  tipo_uso: yup.string().required('El tipo de uso es requerido'),
  tipo_vivienda: yup.string().required('El tipo de vivienda es requerido'),
  como_se_entero: yup.string().required('Cómo se enteró es requerido'),
  valor_plan: yup.string().required('El valor del plan es requerido'),
  bloquear_hasta: yup.string().optional().nullable(),

  estado_pil: yup
    .number()
    .typeError('El estado PyL es requerido')
    .required('El estado PyL es requerido'),
  motivo: yup
    .string()
    .when('estado_pil', {
      is: EstadoPyLCodigoEnum.RECHAZADO,
      then: schema =>
        schema
          .required('El motivo es requerido')
          .max(350, 'La longitud máxima es 350 caracteres'),
    })
    .optional()
    .nullable(),

  ///* fk
  prospecto: yup.number().required('El prospecto es requerido'),
  preventa: yup.number().required('La preventa es requerida'),
  flota: yup
    .number()
    .typeError('La flota es requerida')
    .required('La flota es requerida'),
  plan: yup
    .number()
    .typeError('El plan es requerido')
    .required('El plan es requerido'),

  // user logueado - quien crea la agenda
  user: yup.number().optional().nullable(),
  tipo_documento: yup.string().required('El tipo de documento es requerido'),
  tipo_servicio: yup.string().required('El tipo de servicio es requerido'),
  tipo_instalacion: yup
    .string()
    .required('El tipo de instalación es requerido'),

  nap: yup.string().required('El NAP es requerido'),
  nacionalidad: yup.string().required('La nacionalidad es requerida'),
  pais: yup.string().required('El país es requerido'),
  provincia: yup.string().required('La provincia es requerida'),
  ciudad: yup.string().required('La ciudad es requerida'),

  zona: yup
    .number()
    .typeError('La zona es requerida')
    .required('La zona es requerida'),
  sector: yup
    .number()
    .typeError('El sector es requerido')
    .required('El sector es requerido'),

  cliente: yup.string().optional(),

  // helpers
  zonaLabel: yup.string().optional(),
  sectorLabel: yup.string().optional(),
  celularPrincipal: yup.string().optional(),
  latitud: yup.string().required('La latitud es requerida'),
  longitud: yup.string().required('La longitud es requerida'),
  forma_pago: yup.string().optional(),
});
